module.exports = __webpack_public_path__ + "img/pro_three_5.d00ab421.jpg";